module.exports = vendor_0ef752d415ec4e388d6e;